import es from '@/lang/locales/es.json';
import en from '@/lang/locales/en.json';

export default {
    locale: 'es',
    messages: {
        es: es,
        en: en,
    },
};
